import { createApp } from "vue";

import Antd from "ant-design-vue";
import App from "./App";
import "ant-design-vue/dist/reset.css";

import router from "./router";

import "@/style/index.scss";

// 动态设置根元素字体大小
function setRem() {
  const docEl = document.documentElement;
  const clientWidth = docEl.clientWidth;
  if (!clientWidth) return;
  docEl.style.fontSize = 100 * (clientWidth / 1920) + "px"; // 1920 为设计稿宽度
}

setRem();
window.addEventListener("resize", setRem);

if (!localStorage.getItem("ktr_lang")) {
  localStorage.setItem("ktr_lang", "zh");
}

import i18n from "./i18n/index";

createApp(App).use(router).use(i18n).use(Antd).mount("#app");
